module.exports = __webpack_public_path__ + "static/bello-961b4aed0aaa434dcf9b5dcfa0f544f5.jpg";